import { PaletteOptions, PaletteMode } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unitySemanticDarkColorTokens, unitySemanticLightColorTokens } from '../unityTokens';
import { grey } from './colors';

export const text = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['text'] => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          bold: unitySemanticLightColorTokens['--semantic-text-bold'],
          default: unitySemanticLightColorTokens['--semantic-text-default'],
          disabled: unitySemanticLightColorTokens['--semantic-text-disabled'],
          primary: unitySemanticLightColorTokens['--semantic-text-default'],
          secondary: unitySemanticLightColorTokens['--semantic-text-default'],
          // once we flip the feature flag, we can clean references to these colors up
          inversePrimary: unitySemanticLightColorTokens['--semantic-text-default'],
          inverseSecondary: unitySemanticLightColorTokens['--semantic-text-inverse'],
          navigationHeader: unitySemanticLightColorTokens['--semantic-text-inverse'],
          accent: unitySemanticLightColorTokens['--semantic-text-default'],
        }
      : {
          bold: unitySemanticDarkColorTokens['--semantic-text-bold'],
          default: unitySemanticDarkColorTokens['--semantic-text-default'],
          disabled: unitySemanticDarkColorTokens['--semantic-text-disabled'],
          primary: unitySemanticDarkColorTokens['--semantic-text-default'],
          secondary: unitySemanticDarkColorTokens['--semantic-text-default'],
          // once we flip the feature flag, we can clean references to these colors up
          inversePrimary: unitySemanticDarkColorTokens['--semantic-text-inverse'],
          inverseSecondary: unitySemanticDarkColorTokens['--semantic-text-inverse'],
          navigationHeader: unitySemanticDarkColorTokens['--semantic-text-default'],
          accent: unitySemanticDarkColorTokens['--semantic-text-default'],
        };
  }

  const accent = grey[300];
  return mode === 'light'
    ? {
        // not used unless panwRebrandStubYear is true, but we need to keep the keys for backwards compatibility
        bold: grey[950],
        default: grey[600],
        // ^^^
        primary: grey[950],
        secondary: grey[600],
        disabled: grey[300],
        inversePrimary: grey[50],
        inverseSecondary: grey[200],
        navigationHeader: grey[200],
        accent,
      }
    : {
        // not used unless panwRebrandStubYear is true, but we need to keep the keys for backwards compatibility
        bold: grey[50],
        default: grey[200],
        // ^^^
        primary: grey[50],
        secondary: grey[200],
        disabled: grey[500],
        inversePrimary: grey[950],
        inverseSecondary: grey[600],
        navigationHeader: grey[200],
        accent,
      };
};
